export default __webpack_public_path__ + "static/media/imgBellAlert.82be9311.png";